import en from './locales/en.json';
import de from './locales/de.json';
import fr from './locales/fr.json';
import it from './locales/it.json';

export const defaultLocale = 'de';

export const languages = {
  en,
  de,
  fr,
  it,
};
